import React, { useState } from "react";
import {Modal, ModalContent, ModalHeader, ModalBody, ModalFooter, Button, useDisclosure, Spinner, Input} from "@nextui-org/react";
import { POST } from "../../../../utils/requests";
import { delivery_uri } from "../../../../utils/url";
import { toast } from "react-toastify";

export default function ReqOkayModal({callback, data, user}) {
  const {isOpen, onOpen, onOpenChange} = useDisclosure();
  console.log(user, data);
  const [load, setLoad] = useState(false);

  const handlecal = () => {
    callback();
  }

  const Sub = async () => {
    setLoad(true);
    try{
        const res = await POST({uri:delivery_uri+'/req', data:{id: user.id, phone_no: user.user.phone_no, datas: data}});
        if(res.status === 200){
          setLoad(false);
          toast.success("Амжилттай");
          onOpenChange(false);
          handlecal();
        }
    }catch(err){
        console.log(err);
        setLoad(false);
    }
  }


  return (
    <>
      <Button onPress={onOpen}>Баталгаажуулах</Button>
      <Modal isOpen={isOpen} onOpenChange={onOpenChange} scrollBehavior='inside' size="md">
        <ModalContent>
          {(onClose) => (
            <>
              <ModalBody>
                <div className="font-Roboto mt-6">
                    <h1 className="m-2 uppercase font-bold text-center">Та баталгаажуулахдаа итгэлтэй байна уу ?</h1>
                </div>
              </ModalBody>
              <ModalFooter>
                <Button color="danger" variant="light" onPress={onClose}>
                  Болих
                </Button>
                {
                  load?
                  <Button color="primary">
                    <Spinner color="white"/>
                  </Button>
                  :
                  <Button color="primary" onPress={Sub}>
                    Баталгаажуулах
                  </Button>
                }
              </ModalFooter>
            </>
          )}
        </ModalContent>
      </Modal>
    </>
  );
}